import React, { useState } from "react";
import DisplayAdsCampaignAccordion from "../displayAdsFormComponent/DisplayAdsCampaignAccordion";
import "./DisplayAdsCampaignCreator.scss";
import { Box, Typography } from "@mui/material";
import CloudinaryImageEditor from "../displayAdsFormComponent/AdsCreative/CloudinaryImageEditor";
import LanguageSelection from "../displayAdsFormComponent/CampaignSettings/LanguageSelection";
import CustomOutlinedInput from "components/CustomOutlinedInput/CustomOutlinedInput";
import { validateCampaignName } from "../displayAdsFormComponent/Utils/validators/campaignSettingsValidators";
import { validateFinaleUrl } from "../displayAdsFormComponent/Utils/validators/adsCreativeValidators";

const DisplayAdsCampaignCreator = ({
  campaignName,
  setCampaignName,
  selectedLanguage,
  setSelectedLanguage,
  finalURL,
  setFinalURL,
  landscape,
  setLandscape,
  logo,
  setLogo,
  hotelId,
  accountId,
  onCreateCampaign,
  onCancel,
  errors = {},
}) => {
  const [campaignNameStatus, setCampaignNameStatus] = useState(null);
  const [finalURLStatus, setfinalURLStatus] = useState(null);

  const handleCampaignNameBlur = async (text) => {
    if (!text.trim()) return;

    const result = await validateCampaignName(accountId, hotelId, text);
    if(result.success) {
      delete errors?.campaignName;
    } else {
      errors.campaignName = result.error
    }
    setCampaignNameStatus(
      result.success
        ? { success: true, error: null }
        : { success: false, error: result.error || "Invalid campaign name" }
    );
  };

  const handleFinalURLBlur = async (text) => {
    if (!text.trim()) return;

    const result = await validateFinaleUrl(text);

    if(result.success) {
      delete errors?.finalURL;
    } else {
      errors.finalURL = result.error;
    }
    setfinalURLStatus(
      result.success
        ? { success: true, error: null }
        : { success: false, error: result.error || "Invalid final URL" }
    );
  };

  return (
    <DisplayAdsCampaignAccordion expanded title="Create a Campaign" onSave={onCreateCampaign} onCancel={onCancel}>
      <div className="display-ads-form-wrapper">
        <div className="form-wrapper">
          <Box className="form-section">
            <Typography className="sub-heading">CAMPAIGN</Typography>
            <CustomOutlinedInput
              sx={{ maxWidth: "420px" }}
              value={campaignName}
              onChange={(e) => setCampaignName(e.target.value)}
              onBlur={() => handleCampaignNameBlur(campaignName)}
              helperText={
                errors?.campaignName || (campaignNameStatus
                  ? campaignNameStatus.error || 'CAMPAIGN NAME'
                  : "CAMPAIGN NAME")
              }
              error={errors?.campaignName || (campaignNameStatus && campaignNameStatus.success === false)}
              success={
                campaignNameStatus && campaignNameStatus.success === true
              }
            />
            <CustomOutlinedInput
              sx={{ maxWidth: "420px" }}
              value={finalURL}
              onChange={(e) => setFinalURL(e.target.value)}
              onBlur={() => handleFinalURLBlur(finalURL)}
              helperText={
                errors?.finalURL || (finalURLStatus ? finalURLStatus.error || "URL" : "URL")
              }
              error={errors?.finalURL || (finalURLStatus && finalURLStatus.success === false)}
              success={finalURLStatus && finalURLStatus.success === true}
            />
          </Box>
          <Box className="form-section">
            <Typography className="sub-heading">LANGUAGE</Typography>
            <LanguageSelection
              selectedLanguage={selectedLanguage}
              setSelectedLanguage={setSelectedLanguage}
              errors={errors}
            />
          </Box>
        </div>
        <div className="media-library">
          <Box display="flex" alignItems="center" className="header-box">
            <Typography className="sub-heading">MEDIA LIBRARY</Typography>
          </Box>
          <Box display="flex" className="media-wrapper">
            <CloudinaryImageEditor isEdit={true} setLandscape={setLandscape} setLogo={setLogo} logo={logo} landscape={landscape} errors={errors}/>
          </Box>
        </div>
      </div>
    </DisplayAdsCampaignAccordion>
  );
};

export default DisplayAdsCampaignCreator;
